import { useDispatch } from "react-redux";
import { Box, Typography, Divider, IconButton, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { deleteCurrentReport } from "../../actions/reportsActions";
import { useParams } from "react-router-dom";
import { showAlert } from "../../slices/alertsSlice";
import addHours from "../../utils/addHoursDate";

const { REACT_APP_HOST_URL } = process.env;

const ReportItem = ({ filter, ...props }) => {
  const { investmentId } = useParams();

  const date = addHours(new Date(`${props.date}`), 8);

  const dispatch = useDispatch();

  const handleDelete = (e) => {
    e?.preventDefault();
    const query = { projectRef: props.projectRef };
    props.associateRef ? (query.associateRef = props.associateRef) : null;
    filter ? (query.type = filter) : null;
    dispatch(
      deleteCurrentReport({
        id: props._id,
        query: { ...query, associateInvestmentId: investmentId },
        callback: () => {
          console.log("Close at delete");
          props.onClose();
        },
      })
    );
  };

  const handleClip = () => {
    navigator.clipboard.writeText(
      `https://inversionista.ide.fund/dashboard/proyectos/${props.projectRef}/reportes/${props._id}`
    );
    dispatch(
      showAlert({ message: "Copiado al portapapeles", type: "success" })
    );
  };

  return (
    <>
      <Box
        sx={{
          py: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <a
            href={`${REACT_APP_HOST_URL}/images/reports/${props.path}`}
            target="_blank"
            rel="noreferrer"
          >
            {props.name}
          </a>
          <Typography variant="caption" sx={{ display: "block" }}>
            {`Fecha ${date.getDate()}/${
              date.getMonth() + 1
            }/${date.getFullYear()}`}
          </Typography>
        </Box>
        <Box>
          <Tooltip title="Link de reporte">
            <IconButton onClick={handleClip} size={"small"} color="secondary">
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
          <IconButton onClick={() => props.handleEditReport(props.report)}>
            <Edit />
          </IconButton>
          <IconButton onClick={handleDelete}>
            <Delete />
          </IconButton>
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default ReportItem;
